import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { useCallback } from 'react';

export const ACCOUNT_PURCHASE_REPORT = gql`
  mutation GetAccountPurchaseReport($input: AccountPurchaseReportInput!) {
    getAccountPurchaseReport(input: $input) {
      num_transactions
      num_tickets
      num_participants
      gross_sales
      net_sales
      marketing_fund
      label
      data {
        type
        total
        data {
          id
          purchaser
          total
          subtotal
          refund
          discount
          credit
          fee
          purchase_date
          ticket_holders {
            name
            tickets {
              name
              price
            }
          }
          participants {
            name
            tickets {
              name
              price
            }
          }
        }
      }
    }
  }
`;

export function useGetAccountPurchaseReport({
  account_id,
  type,
  start_date,
  end_date,
}) {
  const [mutation] = useMutation(ACCOUNT_PURCHASE_REPORT);

  const result = useCallback(() => {
    return mutation({
      variables: {
        input: {
          account_id: +account_id,
          type,
          ...(start_date ? { start_date } : null),
          ...(end_date ? { end_date } : null),
        },
      },
    });
  }, [mutation, account_id, type, start_date, end_date]);

  return result;
}
